import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import client from "../../helpers/apolloClient";
import { MeDocument, User } from "../../generated/graphql";

export const getMe = createAsyncThunk("auth/getMe", async () => {
  const { data } = await client.query({
    query: MeDocument,
  });

  return data.me;
});

type AuthSliceState = {
  me: User | null;
  isLogin: boolean;
  isFetched: boolean;
  isLoading: boolean;
};

const initialState: AuthSliceState = {
  me: null,
  isLogin: false,
  isFetched: false,
  isLoading: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setMe(state, action) {
      state.me = action.payload;
    },
    setIsLogin(state, action) {
      state.isLogin = action.payload;
    },
    logout(state) {
      state.me = null;
      state.isLogin = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMe.pending, (state) => {
      state.isLoading = true;
      state.isFetched = false;
    });

    builder.addCase(getMe.fulfilled, (state, action) => {
      state.me = action.payload;
      state.isLogin = state.me ? true : false;
      state.isLoading = false;
      state.isFetched = true;
    });
  },
});

export const { setMe, setIsLogin, logout } = authSlice.actions;

export default authSlice.reducer;
